import { render, staticRenderFns } from "./IdentificationDetails.vue?vue&type=template&id=4c09e4bb&scoped=true"
import script from "./IdentificationDetails.vue?vue&type=script&lang=js"
export * from "./IdentificationDetails.vue?vue&type=script&lang=js"
import style0 from "./IdentificationDetails.vue?vue&type=style&index=0&id=4c09e4bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c09e4bb",
  null
  
)

export default component.exports